class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.showPopularLinks = true;
    this.popularLinks = this.querySelector('[data-popular-links]');
    this.isOpen = false;

    this.collectionsJSON = {};

    this.setupEventListeners();

    //this.getCollectionJSON();
    this.json_result = '';
    this.json_result_match = '';
    this.json_collection = '';
  }

  /*getCollectionJSON() {
    const searchTerm = this.getQuery();
    if (!searchTerm) return;
    fetch('/pages/predictive-collection-json')
      .then((response) => response.text())
      .then((response) => {
        this.collectionsJSON = JSON.parse(response);
        this.getSearchBoost();
      });
  }
  

  getSearchBoost() {
    const searchTerm = this.getQuery();
    if (!this.collectionsJSON) return;
    this.json_result = this.searchCollectionJSON(this.collectionsJSON, searchTerm);
    this.json_result_match = this.searchCollectionMatchJSON(this.collectionsJSON, searchTerm);
    if (this.json_result.length) {
      document.querySelector('#JSON_collections_list').innerHTML = this.getCollectionBoostResult(this.json_result);
    } else if (this.json_result_match.length) {
      document.querySelector('#JSON_collections_list_match').innerHTML = this.getCollectionBoostResult(
        this.json_result_match
      );
      document.querySelector('.searchboost-match').classList.remove('hidden');
    }
  }

  getCollectionBoostResult(json_data) {
    if (!json_data) return;
    var json_results = '';
    for (let i = 0; i < json_data.length; i++) {
      json_results += `<li class="facets__item"><a class="full-unstyled-link" href="${json_data[i].url}">${json_data[i].title}</a></li>`;
    }
    return json_results;
  }
*/
  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  displayPopularLinks() {
    if (this.getQuery().length) return;
    this.showPopularLinks = true;
    this.predictiveSearchResults.innerHTML = '';
    if (this.popularLinks) this.popularLinks.classList.remove('hidden');
  }

  hidePopularLinks() {
    this.showPopularLinks = false;
    if (this.popularLinks) this.popularLinks.classList.add('hidden');
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.displayPopularLinks();
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.displayPopularLinks();
    }

    if (this.getAttribute('results') === 'true' || this.showPopularLinks === true) {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    this.hidePopularLinks();
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  searchCollectionJSON(data, searchQuery) {
    var collections = [];
    for (var k in data) {
      if (data[k].keyword == searchQuery) {
        collections[0] = data[k];
        if (!collections[0].url.includes('?_pos=')) {
          collections[0].url = `${collections[0].url}?_pos=1&_psq=${searchQuery}&_ss=e&_v=1.0`;
        }

        break;
      }
    }
    return collections;
  }

  searchCollectionMatchJSON(data, searchQuery) {
    var collections = [];
    for (var k in data) {
      if (data[k].keyword.includes(searchQuery)) {
        collections[0] = data[k];
        if (!collections[0].url.includes('?_pos=')) {
          collections[0].url = `${collections[0].url}?_pos=1&_psq=${searchQuery}&_ss=e&_v=1.0`;
        }

        break;
      }
    }
    return collections;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.displayPopularLinks();
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
    this.hidePopularLinks();
  }
}

customElements.define('predictive-search', PredictiveSearch);
